import { Controller } from "stimulus"
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export default class extends Controller {
  static targets = ["mynumber"]

  connect() {
    // validations
    let callMeButton = document.querySelector("#callMeButton");
    this.form = FormValidation.formValidation(
      document.getElementById('callMeForm'),
      { 
        fields: {
          myNumber: {
            validators: {
              notEmpty: {
                trim: true,
                message: 'Phone number is required'
              },
              checkValidNumber: {
                message: 'Please enter a valid number',
                callback: function(input) {
                  console.log (isValidPhoneNumber(input.value, 'GB'))
                }
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),

          alias: new FormValidation.plugins.Alias({
            checkValidNumber: 'callback'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
          trigger: new FormValidation.plugins.Trigger(
            {
              event: 'input',
              threshold: 1,
              delay: 1

            }
          ),
      }
    });

  }
}
